<template>
  <div class="home-container">
    <div class="home-content" v-if="fieldName == 'index'">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="场地名称" prop="name" style="width: 80%">
                <el-input
                  v-model="searchForm.name"
                  placeholder="请输入场地名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="启用状态"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="searchForm.status">
                  <el-option label="开启" :value="1"></el-option>
                  <el-option label="关闭" :value="-1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="bindExamine"
          style="width: 90px"
          >审核列表</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="bindRecord"
          style="width: 90px"
          >使用记录</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="sort" label="排序" align="center">
        </el-table-column>
        <el-table-column prop="img" label="场地图片" align="center" width="130">
          <template slot-scope="scope">
            <img  :src="scope.row.img" width="100" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="场地名称" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" align="center">
        </el-table-column>
        <el-table-column prop="recommend" label="场地介绍" align="center">
        </el-table-column>
        <el-table-column prop="illustrate" label="预约说明" align="center">
        </el-table-column>
        <el-table-column prop="status" label="是否启用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column label="预约时间" align="center">
          <template slot-scope="scope">
            <a @click="bindTime(scope.row.id)">预约时间</a>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%" @close="close">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-form-item label="排序" prop="sort">
            <el-input-number 
              v-model="addData.sort" 
              :precision="0" 
              :step="1" 
              :min="1" 
              placeholder="请输入排序"
              controls-position="right"
              @change="$refs.form.validateField('sort')"
              @blur="$refs.form.validateField('sort')">
            </el-input-number>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-form-item label="场地图片" prop="img">
                <upload
                  :url.sync="addData.img"
                  :src="addData.img"
                  type="img"
                  :width="1920"
                  :height="1080"
                ></upload>
                <div style="color: red">*(建议尺寸1920px * 1080px)）</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="场地名称" prop="name">
                <el-input
                  placeholder="请输入场地名称"
                  v-model="addData.name"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预约说明" prop="illustrate">
                <el-input
                  placeholder="请输入预约说明"
                  v-model="addData.illustrate"
                  maxlength="255"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row>
            <el-col :span="24">
              <el-form-item label="场地介绍" prop="recommend">
                <el-input
                  type="textarea"
                  placeholder="请输入场地介绍"
                  :rows="5"
                  v-model="addData.recommend"
                  maxlength="500"
                  show-word-limit
                >
                </el-input>
                <!-- <ueditor v-model="addData.illustrate"></ueditor> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="地址" prop="address">
                <el-input
                  placeholder="请输入地址"
                  v-model="addData.address"
                  maxlength="100"
                >
                </el-input>
                <!-- <ueditor v-model="addData.illustrate"></ueditor> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="12">
              <el-form-item label="联系电话" prop="phone">
                <el-input
                  placeholder="请输入联系电话"
                  v-model="addData.phone"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="是否启用" prop="status">
                <el-switch v-model="addData.status"> </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div v-if="fieldName == 'time'">
      <fieldTime :fieldId="fieldId" @timeBack="timeBack"></fieldTime>
    </div>
    <div v-if="fieldName == 'record'">
      <fieldRecord :fieldId="fieldId" @timeBack="timeBack"></fieldRecord>
    </div>
    <div v-if="fieldName == 'examine'">
      <fieldExamine :fieldId="fieldId" @timeBack="timeBack"></fieldExamine>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
import ueditor from "../../components/ueditor";
import multigraph from "../../components/multigraph";
import fieldTime from "./components/fieldTimes.vue";
import fieldRecord from "./components/fieldRecord.vue";
import fieldExamine from "./components/fieldExamine.vue";
import reg from "../../utils/reg";
export default {
  components: {
    upload,
    ueditor,
    multigraph,
    fieldTime,
    fieldRecord,
    fieldExamine,
  },
  data() {
    return {
      searchForm: {
        site: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        img: [],
        name: "",
        phone: "",
        recommend: "",
        status: "",
        illustrate: "",
        address:""
      },
      addDataRules: {
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        img: [{ required: true, message: "请上传场地图片", trigger: "blur" }],
        name: [{ required: true, message: "请输入场地名称", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: function (rule, value, callback) {
              if (reg.mobile(value) || reg.landline(value)) {
                callback();
              } else {
                callback(new Error("请输入正确的联系电话"));
              }
            },
            trigger: "blur",
          },
        ],
        recommend: [
          { required: true, message: "请输入场地介绍", trigger: "blur" },
        ],
        illustrate: [
          { required: true, message: "请输入预约说明", trigger: "blur" },
        ],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      fieldId: 0,
      fieldName: "index",
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    // 返回
    timeBack() {
      this.fieldName = "index";
    },
    // 使用记录
    bindRecord(id) {
      this.fieldId = id;
      this.fieldName = "record";
    },
    // 预约时间设置
    bindTime(id) {
      console.log(id);
      this.fieldId = id;
      this.fieldName = "time";
    },
    // 审核列表
    bindExamine(id) {
      this.fieldId = id;
      this.fieldName = "examine";
    },
    // 修改状态
    updataStatus(row) {
      row.status = row.status ? 1 : -1;
      // row.img = row.img.join(",");
      this.$Apis.venueBookingAddUp(row).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.status = true;
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    close(){
      this.$refs.form.resetFields();
      this.isAddModal = false;
      this.addData.status = true;
      for (let item in this.addData) {
        this.addData[item] = "";
      }
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      console.log(this.addData);
      this.addData.status = this.addData.status == 1 ? true : false;
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.venueBookingDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            img: this.addData.img,
            illustrate: this.addData.illustrate,
            name: this.addData.name,
            status: this.addData.status ? 1 : -1,
            phone: this.addData.phone,
            recommend: this.addData.recommend,
            address: this.addData.address,
            sort: this.addData.sort
          };
          this.$Apis.venueBookingAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad(ind) {
      this.isShowloading = true;
      if (ind == 1) {
        this.currentPage = 1;
      }
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ...this.searchForm,
      };
      this.$Apis.venueBookingList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.status = item.status == 1 ? true : false;
           
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
.actice .el-upload--picture-card {
  display: none !important;
}
</style>